export default {
  '0105': 'America/New_York',
  '0106': 'America/New_York',
  '0110': 'America/New_York',
  '0111': 'America/New_York',
  '0114': 'America/New_York',
  '0115': 'America/New_York',
  '0116': 'America/New_York',
  '0117': 'America/New_York',
  '0118': 'America/New_York',
  '0119': 'America/New_York',
  '0121': 'America/New_York',
  '0122': 'America/New_York',
  '0123': 'America/New_York',
  '0126': 'America/New_York',
  '0127': 'America/New_York',
  '0128': 'America/New_York',
  '0129': 'America/New_York',
  '0130': 'America/New_York',
  '0131': 'America/New_York',
  '0132': 'America/New_York',
  '0133': 'America/New_York',
  '0134': 'America/New_York',
  '0136': 'America/New_York',
  '0137': 'America/New_York',
  '0138': 'America/New_York',
  '0139': 'America/New_York',
  '0140': 'America/New_York',
  '0141': 'America/New_York',
  '0143': 'America/New_York',
  '0144': 'America/New_York',
  '0145': 'America/New_York',
  '0146': 'America/New_York',
  '0147': 'America/New_York',
  '0148': 'America/New_York',
  '0149': 'America/New_York',
  '0151': 'America/New_York',
  '0152': 'America/New_York',
  '0153': 'America/New_York',
  '0154': 'America/New_York',
  '0155': 'America/New_York',
  '0156': 'America/New_York',
  '0157': 'America/New_York',
  '0159': 'America/New_York',
  '0160': 'America/New_York',
  '0161': 'America/New_York',
  '0163': 'America/New_York',
  '0164': 'America/New_York',
  '0165': 'America/New_York',
  '0170': 'America/New_York',
  '0172': 'America/New_York',
  '0174': 'America/New_York',
  '0175': 'America/New_York',
  '0178': 'America/New_York',
  '0179': 'America/New_York',
  '0201': 'America/New_York',
  '0202': 'America/New_York',
  '0203': 'America/New_York',
  '0204': 'America/New_York',
  '0205': 'America/New_York',
  '0206': 'America/New_York',
  '0207': 'America/New_York',
  '0208': 'America/New_York',
  '0209': 'America/New_York',
  '0210': 'America/New_York',
  '0213': 'America/New_York',
  '0218': 'America/New_York',
  '0220': 'America/New_York',
  '0221': 'America/New_York',
  '0222': 'America/New_York',
  '0224': 'America/New_York',
  '0226': 'America/New_York',
  '0232': 'America/New_York',
  '0233': 'America/New_York',
  '0234': 'America/New_York',
  '0238': 'America/New_York',
  '0243': 'America/New_York',
  '0244': 'America/New_York',
  '0245': 'America/New_York',
  '0247': 'America/New_York',
  '0248': 'America/New_York',
  '0249': 'America/New_York',
  '0251': 'America/New_York',
  '0253': 'America/New_York',
  '0254': 'America/New_York',
  '0255': 'America/New_York',
  '0256': 'America/New_York',
  '0257': 'America/New_York',
  '0258': 'America/New_York',
  '0260': 'America/New_York',
  '0261': 'America/New_York',
  '0262': 'America/New_York',
  '0263': 'America/New_York',
  '0264': 'America/New_York',
  '0265': 'America/New_York',
  '0266': 'America/New_York',
  '0268': 'America/New_York',
  '0270': 'America/New_York',
  '0272': 'America/New_York',
  '0273': 'America/New_York',
  '0274': 'America/New_York',
  '0275': 'America/New_York',
  '0276': 'America/New_York',
  '0277': 'America/New_York',
  '0278': 'America/New_York',
  '0279': 'America/New_York',
  '0280': 'America/New_York',
  '0281': 'America/New_York',
  '0283': 'America/New_York',
  '0284': 'America/New_York',
  '0285': 'America/New_York',
  '0287': 'America/New_York',
  '0288': 'America/New_York',
  '0289': 'America/New_York',
  '0347': 'America/Chicago',
  '0349': 'America/Chicago',
  '0352': 'America/Chicago',
  '0356': 'America/Chicago',
  '0357': 'America/Chicago',
  '0358': 'America/Chicago',
  '0359': 'America/Chicago',
  '0360': 'America/Chicago',
  '0362': 'America/Chicago',
  '0363': 'America/Chicago',
  '0364': 'America/Chicago',
  '0365': 'America/Chicago',
  '0366': 'America/Chicago',
  '0367': 'America/Chicago',
  '0368': 'America/Chicago',
  '0370': 'America/Chicago',
  '0371': 'America/Chicago',
  '0373': 'America/Chicago',
  '0374': 'America/Chicago',
  '0375': 'America/Chicago',
  '0376': 'America/Chicago',
  '0378': 'America/Chicago',
  '0380': 'America/Chicago',
  '0381': 'America/Chicago',
  '0383': 'America/Chicago',
  '0385': 'America/Chicago',
  '0386': 'America/Chicago',
  '0389': 'America/Chicago',
  '0401': 'America/Phoenix',
  '0402': 'America/Phoenix',
  '0403': 'America/Phoenix',
  '0404': 'America/Phoenix',
  '0405': 'America/Phoenix',
  '0406': 'America/Phoenix',
  '0408': 'America/Phoenix',
  '0410': 'America/Phoenix',
  '0411': 'America/Phoenix',
  '0413': 'America/Phoenix',
  '0414': 'America/Phoenix',
  '0415': 'America/Phoenix',
  '0416': 'America/Phoenix',
  '0417': 'America/Phoenix',
  '0420': 'America/Phoenix',
  '0421': 'America/Phoenix',
  '0422': 'America/Phoenix',
  '0423': 'America/Phoenix',
  '0424': 'America/Phoenix',
  '0441': 'America/Phoenix',
  '0442': 'America/Phoenix',
  '0443': 'America/Phoenix',
  '0445': 'America/Phoenix',
  '0446': 'America/Phoenix',
  '0447': 'America/Phoenix',
  '0452': 'America/Phoenix',
  '0453': 'America/Phoenix',
  '0455': 'America/Phoenix',
  '0456': 'America/Phoenix',
  '0457': 'America/Phoenix',
  '0458': 'America/Phoenix',
  '0459': 'America/Phoenix',
  '0464': 'America/Phoenix',
  '0467': 'America/Phoenix',
  '0468': 'America/Phoenix',
  '0469': 'America/Phoenix',
  '0470': 'America/Phoenix',
  '0471': 'America/Phoenix',
  '0472': 'America/Phoenix',
  '0473': 'America/Phoenix',
  '0475': 'America/Phoenix',
  '0476': 'America/Phoenix',
  '0477': 'America/Phoenix',
  '0478': 'America/Phoenix',
  '0480': 'America/Phoenix',
  '0481': 'America/Phoenix',
  '0482': 'America/Phoenix',
  '0483': 'America/Phoenix',
  '0485': 'America/Phoenix',
  '0486': 'America/Phoenix',
  '0488': 'America/Phoenix',
  '0489': 'America/Phoenix',
  '0501': 'America/Chicago',
  '0503': 'America/Chicago',
  '0504': 'America/Chicago',
  '0505': 'America/Chicago',
  '0506': 'America/Chicago',
  '0507': 'America/Chicago',
  '0508': 'America/Chicago',
  '0509': 'America/Chicago',
  '0513': 'America/Chicago',
  '0514': 'America/Chicago',
  '0516': 'America/Chicago',
  '0518': 'America/Chicago',
  '0519': 'America/Chicago',
  '0522': 'America/Denver',
  '0523': 'America/Denver',
  '0524': 'America/Chicago',
  '0526': 'America/Chicago',
  '0527': 'America/Chicago',
  '0528': 'America/Chicago',
  '0529': 'America/Chicago',
  '0530': 'America/Chicago',
  '0531': 'America/Chicago',
  '0534': 'America/Chicago',
  '0537': 'America/Chicago',
  '0539': 'America/Chicago',
  '0540': 'America/Chicago',
  '0541': 'America/Chicago',
  '0542': 'America/Chicago',
  '0550': 'America/Chicago',
  '0551': 'America/Chicago',
  '0552': 'America/Chicago',
  '0553': 'America/Chicago',
  '0554': 'America/Chicago',
  '0555': 'America/Chicago',
  '0556': 'America/Chicago',
  '0561': 'America/Chicago',
  '0562': 'America/Chicago',
  '0563': 'America/Chicago',
  '0564': 'America/Chicago',
  '0565': 'America/Chicago',
  '0566': 'America/Chicago',
  '0568': 'America/Chicago',
  '0569': 'America/Chicago',
  '0571': 'America/Chicago',
  '0574': 'America/Chicago',
  '0576': 'America/Chicago',
  '0577': 'America/Chicago',
  '0578': 'America/Chicago',
  '0580': 'America/Chicago',
  '0581': 'America/Chicago',
  '0582': 'America/Chicago',
  '0584': 'America/Chicago',
  '0585': 'America/Chicago',
  '0586': 'America/Chicago',
  '0587': 'America/Chicago',
  '0588': 'America/Chicago',
  '0589': 'America/Chicago',
  '0601': 'America/Los_Angeles',
  '0603': 'America/Los_Angeles',
  '0606': 'America/Los_Angeles',
  '0607': 'America/Los_Angeles',
  '0608': 'America/Los_Angeles',
  '0609': 'America/Los_Angeles',
  '0610': 'America/Los_Angeles',
  '0611': 'America/Los_Angeles',
  '0612': 'America/Los_Angeles',
  '0614': 'America/Los_Angeles',
  '0615': 'America/Los_Angeles',
  '0616': 'America/Los_Angeles',
  '0618': 'America/Los_Angeles',
  '0620': 'America/Los_Angeles',
  '0622': 'America/Los_Angeles',
  '0625': 'America/Los_Angeles',
  '0627': 'America/Los_Angeles',
  '0628': 'America/Los_Angeles',
  '0629': 'America/Los_Angeles',
  '0630': 'America/Los_Angeles',
  '0632': 'America/Los_Angeles',
  '0633': 'America/Los_Angeles',
  '0634': 'America/Los_Angeles',
  '0635': 'America/Los_Angeles',
  '0636': 'America/Los_Angeles',
  '0637': 'America/Los_Angeles',
  '0638': 'America/Los_Angeles',
  '0639': 'America/Los_Angeles',
  '0640': 'America/Los_Angeles',
  '0641': 'America/Los_Angeles',
  '0642': 'America/Los_Angeles',
  '0643': 'America/Los_Angeles',
  '0644': 'America/Los_Angeles',
  '0645': 'America/Los_Angeles',
  '0647': 'America/Los_Angeles',
  '0648': 'America/Los_Angeles',
  '0649': 'America/Los_Angeles',
  '0650': 'America/Los_Angeles',
  '0651': 'America/Los_Angeles',
  '0652': 'America/Los_Angeles',
  '0653': 'America/Los_Angeles',
  '0654': 'America/Los_Angeles',
  '0657': 'America/Los_Angeles',
  '0658': 'America/Los_Angeles',
  '0659': 'America/Los_Angeles',
  '0660': 'America/Los_Angeles',
  '0662': 'America/Los_Angeles',
  '0663': 'America/Los_Angeles',
  '0664': 'America/Los_Angeles',
  '0665': 'America/Los_Angeles',
  '0667': 'America/Los_Angeles',
  '0668': 'America/Los_Angeles',
  '0669': 'America/Los_Angeles',
  '0671': 'America/Los_Angeles',
  '0673': 'America/Los_Angeles',
  '0674': 'America/Los_Angeles',
  '0679': 'America/Los_Angeles',
  '0680': 'America/Los_Angeles',
  '0683': 'America/Los_Angeles',
  '0684': 'America/Los_Angeles',
  '0687': 'America/Los_Angeles',
  '0701': 'America/New_York',
  '0702': 'America/New_York',
  '0703': 'America/Chicago',
  '0704': 'America/Chicago',
  '0707': 'America/Chicago',
  '0720': 'America/Chicago',
  '0721': 'America/Chicago',
  '0722': 'America/Chicago',
  '0723': 'America/Chicago',
  '0724': 'America/New_York',
  '0725': 'America/Chicago',
  '0726': 'America/Chicago',
  '0727': 'America/Chicago',
  '0728': 'America/New_York',
  '0729': 'America/Chicago',
  '0730': 'America/New_York',
  '0731': 'America/New_York',
  '0732': 'America/Chicago',
  '0733': 'America/Chicago',
  '0734': 'America/Chicago',
  '0735': 'America/Chicago',
  '0736': 'America/New_York',
  '0737': 'America/Chicago',
  '0739': 'America/New_York',
  '0740': 'America/New_York',
  '0742': 'America/New_York',
  '0743': 'America/New_York',
  '0744': 'America/New_York',
  '0745': 'America/Chicago',
  '0747': 'America/Chicago',
  '0748': 'America/Chicago',
  '0770': 'America/New_York',
  '0772': 'America/Chicago',
  '0773': 'America/New_York',
  '0775': 'America/Chicago',
  '0776': 'America/Chicago',
  '0778': 'America/Chicago',
  '0779': 'America/Chicago',
  '0801': 'America/Chicago',
  '0802': 'America/Chicago',
  '0803': 'America/Chicago',
  '0804': 'America/Chicago',
  '0805': 'America/Chicago',
  '0806': 'America/Chicago',
  '0808': 'America/Chicago',
  '0809': 'America/Chicago',
  '0810': 'America/Chicago',
  '0812': 'America/Chicago',
  '0813': 'America/Chicago',
  '0816': 'America/Chicago',
  '0817': 'America/Chicago',
  '0818': 'America/Chicago',
  '0863': 'America/Chicago',
  '0865': 'America/Chicago',
  '0866': 'America/Chicago',
  '0875': 'America/Chicago',
  '0877': 'America/Chicago',
  '0880': 'America/Chicago',
  '0881': 'America/Chicago',
  '0882': 'America/Chicago',
  '0883': 'America/Chicago',
  '0884': 'America/Chicago',
  '0887': 'America/Chicago',
  '0888': 'America/Chicago',
  '0901': 'America/New_York',
  '0902': 'America/New_York',
  '0903': 'America/New_York',
  '0904': 'America/New_York',
  '0906': 'America/New_York',
  '0907': 'America/New_York',
  '0908': 'America/New_York',
  '0909': 'America/New_York',
  '0910': 'America/New_York',
  '0912': 'America/New_York',
  '0914': 'America/New_York',
  '0915': 'America/New_York',
  '0916': 'America/New_York',
  '0917': 'America/New_York',
  '0918': 'America/New_York',
  '0919': 'America/New_York',
  '0920': 'America/New_York',
  '0921': 'America/New_York',
  '0922': 'America/New_York',
  '0925': 'America/New_York',
  '0926': 'America/New_York',
  '0927': 'America/New_York',
  '0928': 'America/New_York',
  '0929': 'America/New_York',
  '0930': 'America/New_York',
  '0931': 'America/New_York',
  '0932': 'America/New_York',
  '0933': 'America/New_York',
  '0934': 'America/New_York',
  '0935': 'America/New_York',
  '0939': 'America/New_York',
  '0940': 'America/New_York',
  '0941': 'America/New_York',
  '0942': 'America/New_York',
  '0943': 'America/New_York',
  '0944': 'America/New_York',
  '0946': 'America/New_York',
  '0947': 'America/New_York',
  '0949': 'America/New_York',
  '0950': 'America/New_York',
  '0951': 'America/New_York',
  '0953': 'America/New_York',
  '0954': 'America/New_York',
  '0957': 'America/New_York',
  '0959': 'America/New_York',
  '0961': 'America/New_York',
  '0962': 'America/New_York',
  '0963': 'America/New_York',
  '0965': 'America/New_York',
  '0969': 'America/New_York',
  '0970': 'America/New_York',
  '0974': 'America/New_York',
  '0975': 'America/New_York',
  '0976': 'America/New_York',
  '0977': 'America/New_York',
  '0980': 'America/New_York',
  '0981': 'America/New_York',
  '0982': 'America/New_York',
  '0983': 'America/New_York',
  '0984': 'America/New_York',
  '0989': 'America/New_York',
  1001: 'America/Los_Angeles',
  1002: 'America/Los_Angeles',
  1003: 'America/Los_Angeles',
  1005: 'America/Los_Angeles',
  1006: 'America/Los_Angeles',
  1007: 'America/Los_Angeles',
  1009: 'America/Los_Angeles',
  1010: 'America/Los_Angeles',
  1012: 'America/Los_Angeles',
  1013: 'America/Los_Angeles',
  1014: 'America/Los_Angeles',
  1017: 'America/Los_Angeles',
  1018: 'America/Los_Angeles',
  1019: 'America/Los_Angeles',
  1020: 'America/Los_Angeles',
  1022: 'America/Los_Angeles',
  1028: 'America/Los_Angeles',
  1030: 'America/Los_Angeles',
  1031: 'America/Los_Angeles',
  1032: 'America/Los_Angeles',
  1034: 'America/Los_Angeles',
  1037: 'America/Los_Angeles',
  1039: 'America/Los_Angeles',
  1040: 'America/Los_Angeles',
  1041: 'America/Los_Angeles',
  1043: 'America/Los_Angeles',
  1044: 'America/Los_Angeles',
  1048: 'America/Los_Angeles',
  1050: 'America/Los_Angeles',
  1052: 'America/Los_Angeles',
  1053: 'America/Los_Angeles',
  1055: 'America/Los_Angeles',
  1059: 'America/Los_Angeles',
  1060: 'America/Los_Angeles',
  1061: 'America/Los_Angeles',
  1062: 'America/Los_Angeles',
  1064: 'America/Los_Angeles',
  1068: 'America/Los_Angeles',
  1069: 'America/Los_Angeles',
  1070: 'America/Los_Angeles',
  1072: 'America/Los_Angeles',
  1073: 'America/Los_Angeles',
  1074: 'America/Los_Angeles',
  1076: 'America/Los_Angeles',
  1077: 'America/Los_Angeles',
  1080: 'America/Los_Angeles',
  1083: 'America/Los_Angeles',
  1084: 'America/Los_Angeles',
  1085: 'America/Los_Angeles',
  1086: 'America/Los_Angeles',
  1087: 'America/Los_Angeles',
  1088: 'America/Los_Angeles',
  1089: 'America/Los_Angeles',
  1092: 'America/Los_Angeles',
  1103: 'America/New_York',
  1104: 'America/New_York',
  1105: 'America/New_York',
  1106: 'America/New_York',
  1108: 'America/New_York',
  1109: 'America/New_York',
  1110: 'America/New_York',
  1112: 'America/New_York',
  1114: 'America/New_York',
  1115: 'America/New_York',
  1116: 'America/New_York',
  1117: 'America/New_York',
  1118: 'America/New_York',
  1119: 'America/New_York',
  1120: 'America/New_York',
  1121: 'America/New_York',
  1122: 'America/New_York',
  1124: 'America/New_York',
  1126: 'America/New_York',
  1127: 'America/New_York',
  1129: 'America/New_York',
  1130: 'America/New_York',
  1171: 'America/New_York',
  1202: 'America/New_York',
  1206: 'America/New_York',
  1207: 'America/New_York',
  1208: 'America/New_York',
  1209: 'America/New_York',
  1211: 'America/New_York',
  1212: 'America/New_York',
  1213: 'America/New_York',
  1214: 'America/New_York',
  1215: 'America/New_York',
  1216: 'America/New_York',
  1217: 'America/New_York',
  1218: 'America/New_York',
  1220: 'America/New_York',
  1221: 'America/New_York',
  1222: 'America/New_York',
  1223: 'America/New_York',
  1225: 'America/New_York',
  1227: 'America/New_York',
  1228: 'America/New_York',
  1229: 'America/New_York',
  1230: 'America/New_York',
  1231: 'America/New_York',
  1233: 'America/New_York',
  1234: 'America/New_York',
  1235: 'America/New_York',
  1236: 'America/New_York',
  1238: 'America/New_York',
  1239: 'America/New_York',
  1241: 'America/New_York',
  1242: 'America/New_York',
  1244: 'America/New_York',
  1245: 'America/New_York',
  1246: 'America/New_York',
  1247: 'America/New_York',
  1248: 'America/New_York',
  1249: 'America/New_York',
  1250: 'America/New_York',
  1251: 'America/New_York',
  1252: 'America/New_York',
  1254: 'America/New_York',
  1255: 'America/New_York',
  1256: 'America/New_York',
  1257: 'America/New_York',
  1258: 'America/New_York',
  1259: 'America/New_York',
  1261: 'America/New_York',
  1262: 'America/New_York',
  1263: 'America/New_York',
  1264: 'America/New_York',
  1265: 'America/New_York',
  1266: 'America/New_York',
  1267: 'America/New_York',
  1268: 'America/New_York',
  1269: 'America/New_York',
  1271: 'America/New_York',
  1272: 'America/New_York',
  1273: 'America/New_York',
  1274: 'America/New_York',
  1277: 'America/New_York',
  1278: 'America/New_York',
  1281: 'America/New_York',
  1282: 'America/New_York',
  1284: 'America/New_York',
  1285: 'America/New_York',
  1286: 'America/New_York',
  1287: 'America/New_York',
  1289: 'America/New_York',
  1301: 'America/Anchorage',
  1302: 'America/Anchorage',
  1303: 'America/Anchorage',
  1304: 'America/Anchorage',
  1324: 'America/New_York',
  1379: 'America/Los_Angeles',
  1380: 'America/Los_Angeles',
  1401: 'America/Chicago',
  1402: 'America/Chicago',
  1403: 'America/Chicago',
  1404: 'America/Chicago',
  1405: 'America/Chicago',
  1406: 'America/Chicago',
  1407: 'America/Chicago',
  1409: 'America/Chicago',
  1410: 'America/Chicago',
  1411: 'America/Chicago',
  1412: 'America/Chicago',
  1501: 'America/Denver',
  1502: 'America/Denver',
  1503: 'America/Denver',
  1504: 'America/Denver',
  1505: 'America/Denver',
  1506: 'America/Denver',
  1507: 'America/Denver',
  1508: 'America/Denver',
  1509: 'America/Denver',
  1510: 'America/Denver',
  1511: 'America/Denver',
  1512: 'America/Denver',
  1513: 'America/Denver',
  1514: 'America/Denver',
  1515: 'America/Denver',
  1516: 'America/Denver',
  1517: 'America/Denver',
  1518: 'America/Denver',
  1519: 'America/Denver',
  1520: 'America/Denver',
  1521: 'America/Denver',
  1522: 'America/Denver',
  1523: 'America/Denver',
  1524: 'America/Denver',
  1525: 'America/Denver',
  1526: 'America/Denver',
  1528: 'America/Denver',
  1529: 'America/Denver',
  1531: 'America/Denver',
  1532: 'America/Denver',
  1534: 'America/Denver',
  1535: 'America/Denver',
  1537: 'America/Denver',
  1538: 'America/Denver',
  1540: 'America/Denver',
  1541: 'America/Denver',
  1542: 'America/Denver',
  1544: 'America/Denver',
  1545: 'America/Denver',
  1546: 'America/Denver',
  1547: 'America/Denver',
  1548: 'America/Denver',
  1549: 'America/Denver',
  1550: 'America/Denver',
  1551: 'America/Denver',
  1552: 'America/Denver',
  1601: 'America/New_York',
  1602: 'America/New_York',
  1603: 'America/New_York',
  1604: 'America/New_York',
  1605: 'America/New_York',
  1608: 'America/New_York',
  1610: 'America/New_York',
  1701: 'Pacific/Honolulu',
  1702: 'Pacific/Honolulu',
  1703: 'Pacific/Honolulu',
  1704: 'Pacific/Honolulu',
  1705: 'Pacific/Honolulu',
  1706: 'Pacific/Honolulu',
  1710: 'Pacific/Guam',
  1747: 'America/New_York',
  1748: 'America/New_York',
  1749: 'America/New_York',
  1750: 'America/New_York',
  1754: 'America/New_York',
  1755: 'America/New_York',
  1763: 'America/New_York',
  1764: 'America/New_York',
  1769: 'America/New_York',
  1770: 'America/New_York',
  1771: 'America/New_York',
  1772: 'America/New_York',
  1773: 'America/New_York',
  1774: 'America/New_York',
  1775: 'America/New_York',
  1777: 'America/New_York',
  1801: 'America/Boise',
  1802: 'America/Boise',
  1803: 'America/Los_Angeles',
  1804: 'America/Boise',
  1805: 'America/Boise',
  1806: 'America/Boise',
  1807: 'America/Boise',
  1808: 'America/Los_Angeles',
  1809: 'America/Boise',
  1810: 'America/Los_Angeles',
  1832: 'America/Chicago',
  1840: 'America/Los_Angeles',
  1842: 'America/Los_Angeles',
  1843: 'America/Los_Angeles',
  1844: 'America/Los_Angeles',
  1845: 'America/Los_Angeles',
  1846: 'America/Los_Angeles',
  1848: 'America/Los_Angeles',
  1851: 'America/Chicago',
  1853: 'America/Chicago',
  1854: 'America/New_York',
  1855: 'America/New_York',
  1856: 'America/New_York',
  1857: 'America/Los_Angeles',
  1858: 'America/Los_Angeles',
  1859: 'America/Chicago',
  1861: 'America/Los_Angeles',
  1863: 'America/New_York',
  1901: 'America/Chicago',
  1902: 'America/Chicago',
  1903: 'America/Chicago',
  1904: 'America/Chicago',
  1905: 'America/Chicago',
  1906: 'America/Chicago',
  1907: 'America/Chicago',
  1908: 'America/Chicago',
  1909: 'America/Chicago',
  1911: 'America/Chicago',
  1912: 'America/Chicago',
  1913: 'America/Chicago',
  1914: 'America/Chicago',
  1915: 'America/Chicago',
  1916: 'America/Chicago',
  1917: 'America/Chicago',
  1918: 'America/Chicago',
  1919: 'America/Chicago',
  1920: 'America/Chicago',
  1921: 'America/Chicago',
  1922: 'America/Chicago',
  1924: 'America/Chicago',
  1926: 'America/Chicago',
  1927: 'America/Chicago',
  1928: 'America/Chicago',
  1932: 'America/Chicago',
  1934: 'America/Chicago',
  1935: 'America/Chicago',
  1936: 'America/Chicago',
  1937: 'America/Chicago',
  1938: 'America/Chicago',
  1939: 'America/Chicago',
  1940: 'America/Chicago',
  1941: 'America/Chicago',
  1942: 'America/Chicago',
  1943: 'America/Chicago',
  1944: 'America/Chicago',
  1948: 'America/Chicago',
  1950: 'America/Chicago',
  1952: 'America/Chicago',
  1955: 'America/Chicago',
  1956: 'America/Chicago',
  1957: 'America/Chicago',
  1961: 'America/Chicago',
  1962: 'America/Chicago',
  1964: 'America/Chicago',
  1967: 'America/Chicago',
  1969: 'America/Chicago',
  1973: 'America/Chicago',
  1974: 'America/Chicago',
  1975: 'America/Chicago',
  1976: 'America/Chicago',
  1977: 'America/Chicago',
  1978: 'America/Chicago',
  1979: 'America/Chicago',
  1980: 'America/Chicago',
  1981: 'America/Chicago',
  1982: 'America/Chicago',
  1983: 'America/Chicago',
  1984: 'America/Chicago',
  1986: 'America/Chicago',
  1987: 'America/Chicago',
  1989: 'America/Chicago',
  2001: 'America/Chicago',
  2002: 'America/New_York',
  2003: 'America/Chicago',
  2009: 'America/Indiana/Indianapolis',
  2010: 'America/Chicago',
  2011: 'America/Indiana/Indianapolis',
  2012: 'America/Indiana/Indianapolis',
  2014: 'America/Indiana/Indianapolis',
  2016: 'America/New_York',
  2017: 'America/Indiana/Indianapolis',
  2018: 'America/Indiana/Indianapolis',
  2019: 'America/Indiana/Indianapolis',
  2021: 'America/Indiana/Indianapolis',
  2023: 'America/Indiana/Indianapolis',
  2024: 'America/Indiana/Indianapolis',
  2025: 'America/Indiana/Vincennes',
  2026: 'America/Indiana/Indianapolis',
  2030: 'America/Chicago',
  2033: 'America/Indiana/Indianapolis',
  2034: 'America/Indiana/Indianapolis',
  2036: 'America/Chicago',
  2037: 'America/Indiana/Indianapolis',
  2101: 'America/Chicago',
  2103: 'America/Chicago',
  2104: 'America/Chicago',
  2107: 'America/Chicago',
  2108: 'America/Chicago',
  2109: 'America/Chicago',
  2111: 'America/Chicago',
  2113: 'America/Chicago',
  2114: 'America/Chicago',
  2115: 'America/Chicago',
  2201: 'America/Chicago',
  2202: 'America/Chicago',
  2203: 'America/Chicago',
  2204: 'America/Chicago',
  2205: 'America/Chicago',
  2207: 'America/Chicago',
  2209: 'America/Chicago',
  2211: 'America/Chicago',
  2213: 'America/Chicago',
  2214: 'America/Chicago',
  2216: 'America/Chicago',
  2217: 'America/Chicago',
  2218: 'America/Chicago',
  2219: 'America/Chicago',
  2220: 'America/Chicago',
  2221: 'America/Chicago',
  2301: 'America/New_York',
  2302: 'America/New_York',
  2303: 'America/New_York',
  2304: 'America/Los_Angeles',
  2305: 'America/New_York',
  2306: 'America/New_York',
  2307: 'America/New_York',
  2313: 'America/New_York',
  2314: 'America/Chicago',
  2315: 'America/New_York',
  2316: 'America/New_York',
  2317: 'America/Chicago',
  2318: 'America/Chicago',
  2323: 'America/New_York',
  2324: 'America/New_York',
  2389: 'America/Chicago',
  2401: 'America/New_York',
  2403: 'America/New_York',
  2404: 'America/New_York',
  2405: 'America/New_York',
  2406: 'America/New_York',
  2407: 'America/New_York',
  2408: 'America/New_York',
  2409: 'America/New_York',
  2410: 'America/New_York',
  2412: 'America/New_York',
  2414: 'America/New_York',
  2501: 'America/New_York',
  2502: 'America/New_York',
  2503: 'America/New_York',
  2504: 'America/New_York',
  2505: 'America/New_York',
  2506: 'America/New_York',
  2507: 'America/New_York',
  2509: 'America/New_York',
  2510: 'America/New_York',
  2511: 'America/New_York',
  2550: 'America/New_York',
  2551: 'America/New_York',
  2552: 'America/New_York',
  2554: 'America/New_York',
  2555: 'America/New_York',
  2557: 'America/New_York',
  2558: 'America/New_York',
  2559: 'America/New_York',
  2560: 'America/New_York',
  2561: 'America/New_York',
  2562: 'America/New_York',
  2563: 'America/New_York',
  2564: 'America/New_York',
  2565: 'America/New_York',
  2566: 'America/New_York',
  2567: 'America/New_York',
  2571: 'America/New_York',
  2575: 'America/New_York',
  2576: 'America/New_York',
  2577: 'America/New_York',
  2578: 'America/New_York',
  2579: 'America/New_York',
  2580: 'America/New_York',
  2581: 'America/New_York',
  2582: 'America/New_York',
  2583: 'America/New_York',
  2584: 'America/New_York',
  2587: 'America/New_York',
  2589: 'America/New_York',
  2602: 'America/New_York',
  2603: 'America/New_York',
  2605: 'America/New_York',
  2607: 'America/New_York',
  2608: 'America/New_York',
  2609: 'America/New_York',
  2610: 'America/New_York',
  2611: 'America/New_York',
  2612: 'America/New_York',
  2613: 'America/New_York',
  2614: 'America/New_York',
  2615: 'America/New_York',
  2619: 'America/New_York',
  2623: 'America/New_York',
  2624: 'America/New_York',
  2650: 'America/New_York',
  2651: 'America/New_York',
  2653: 'America/New_York',
  2659: 'America/New_York',
  2662: 'America/New_York',
  2663: 'America/New_York',
  2665: 'America/New_York',
  2667: 'America/New_York',
  2668: 'America/New_York',
  2669: 'America/New_York',
  2670: 'America/New_York',
  2671: 'America/New_York',
  2672: 'America/New_York',
  2673: 'America/New_York',
  2674: 'America/New_York',
  2676: 'America/New_York',
  2677: 'America/New_York',
  2678: 'America/New_York',
  2679: 'America/New_York',
  2680: 'America/New_York',
  2681: 'America/New_York',
  2682: 'America/New_York',
  2683: 'America/New_York',
  2684: 'America/New_York',
  2685: 'America/New_York',
  2686: 'America/New_York',
  2688: 'America/New_York',
  2701: 'America/Detroit',
  2702: 'America/Detroit',
  2703: 'America/Detroit',
  2704: 'America/Detroit',
  2706: 'America/Detroit',
  2707: 'America/Detroit',
  2708: 'America/Detroit',
  2709: 'America/Detroit',
  2710: 'America/Detroit',
  2711: 'America/Detroit',
  2714: 'America/Detroit',
  2715: 'America/Detroit',
  2716: 'America/Detroit',
  2717: 'America/Detroit',
  2718: 'America/Detroit',
  2720: 'America/Detroit',
  2721: 'America/Detroit',
  2722: 'America/Detroit',
  2723: 'America/Detroit',
  2724: 'America/Detroit',
  2725: 'America/Detroit',
  2726: 'America/Detroit',
  2727: 'America/Detroit',
  2728: 'America/Detroit',
  2729: 'America/Detroit',
  2731: 'America/Detroit',
  2732: 'America/Detroit',
  2733: 'America/Detroit',
  2734: 'America/Detroit',
  2736: 'America/Detroit',
  2737: 'America/Detroit',
  2738: 'America/Detroit',
  2739: 'America/Detroit',
  2740: 'America/Detroit',
  2741: 'America/Detroit',
  2742: 'America/Detroit',
  2743: 'America/Detroit',
  2744: 'America/Detroit',
  2747: 'America/Detroit',
  2748: 'America/Detroit',
  2751: 'America/Detroit',
  2752: 'America/Detroit',
  2754: 'America/Detroit',
  2755: 'America/Detroit',
  2757: 'America/Detroit',
  2758: 'America/Detroit',
  2759: 'America/Detroit',
  2760: 'America/Detroit',
  2761: 'America/Detroit',
  2762: 'America/Detroit',
  2763: 'America/Detroit',
  2764: 'America/Detroit',
  2765: 'America/Detroit',
  2766: 'America/Detroit',
  2767: 'America/Detroit',
  2768: 'America/Detroit',
  2769: 'America/Detroit',
  2770: 'America/Detroit',
  2771: 'America/Detroit',
  2772: 'America/Detroit',
  2773: 'America/Detroit',
  2775: 'America/Chicago',
  2776: 'America/Detroit',
  2779: 'America/Detroit',
  2780: 'America/Detroit',
  2781: 'America/Detroit',
  2782: 'America/Detroit',
  2785: 'America/Detroit',
  2789: 'America/Detroit',
  2801: 'America/Chicago',
  2802: 'America/Chicago',
  2803: 'America/Chicago',
  2804: 'America/Chicago',
  2805: 'America/Chicago',
  2806: 'America/Chicago',
  2807: 'America/Chicago',
  2808: 'America/Chicago',
  2809: 'America/Chicago',
  2810: 'America/Chicago',
  2811: 'America/Chicago',
  2812: 'America/Chicago',
  2813: 'America/Chicago',
  2817: 'America/Chicago',
  2818: 'America/Chicago',
  2820: 'America/Chicago',
  2821: 'America/Chicago',
  2825: 'America/Chicago',
  2826: 'America/Chicago',
  2828: 'America/Chicago',
  2829: 'America/Chicago',
  2830: 'America/Chicago',
  2831: 'America/Chicago',
  2832: 'America/Chicago',
  2833: 'America/Chicago',
  2834: 'America/Chicago',
  2840: 'America/Chicago',
  2841: 'America/Chicago',
  2842: 'America/Chicago',
  2843: 'America/Chicago',
  2844: 'America/Chicago',
  2845: 'America/Chicago',
  2847: 'America/Chicago',
  2901: 'America/Chicago',
  2902: 'America/Chicago',
  2903: 'America/Chicago',
  2905: 'America/Chicago',
  2906: 'America/Chicago',
  2907: 'America/Chicago',
  2909: 'America/Chicago',
  2910: 'America/Chicago',
  2912: 'America/Chicago',
  2913: 'America/Chicago',
  2914: 'America/Chicago',
  2915: 'America/Chicago',
  2917: 'America/Chicago',
  3001: 'America/Chicago',
  3002: 'America/Chicago',
  3003: 'America/Chicago',
  3004: 'America/Chicago',
  3006: 'America/Chicago',
  3007: 'America/Chicago',
  3008: 'America/Chicago',
  3009: 'America/Chicago',
  3010: 'America/Chicago',
  3011: 'America/Chicago',
  3012: 'America/Chicago',
  3013: 'America/Chicago',
  3014: 'America/Chicago',
  3015: 'America/Chicago',
  3016: 'America/Chicago',
  3018: 'America/Chicago',
  3019: 'America/Chicago',
  3021: 'America/Chicago',
  3022: 'America/Chicago',
  3024: 'America/Chicago',
  3025: 'America/Chicago',
  3026: 'America/Chicago',
  3027: 'America/Chicago',
  3029: 'America/Chicago',
  3032: 'America/Chicago',
  3033: 'America/Chicago',
  3034: 'America/Chicago',
  3036: 'America/Chicago',
  3037: 'America/Chicago',
  3038: 'America/Chicago',
  3042: 'America/Chicago',
  3101: 'America/Denver',
  3102: 'America/Denver',
  3103: 'America/Denver',
  3104: 'America/Denver',
  3105: 'America/Denver',
  3106: 'America/Denver',
  3201: 'America/Chicago',
  3202: 'America/Chicago',
  3203: 'America/Chicago',
  3204: 'America/Chicago',
  3206: 'America/Chicago',
  3208: 'America/Chicago',
  3209: 'America/Chicago',
  3210: 'America/Denver',
  3301: 'America/Los_Angeles',
  3302: 'America/Los_Angeles',
  3303: 'America/Los_Angeles',
  3304: 'America/Los_Angeles',
  3305: 'America/Los_Angeles',
  3306: 'America/Los_Angeles',
  3307: 'America/Los_Angeles',
  3308: 'America/Los_Angeles',
  3309: 'America/Los_Angeles',
  3310: 'America/Los_Angeles',
  3311: 'America/Los_Angeles',
  3312: 'America/Los_Angeles',
  3313: 'America/Los_Angeles',
  3314: 'America/Los_Angeles',
  3315: 'America/Los_Angeles',
  3316: 'America/Los_Angeles',
  3318: 'America/Los_Angeles',
  3320: 'America/Los_Angeles',
  3322: 'America/Los_Angeles',
  3324: 'America/Los_Angeles',
  3331: 'America/New_York',
  3401: 'America/New_York',
  3402: 'America/New_York',
  3403: 'America/New_York',
  3404: 'America/New_York',
  3405: 'America/New_York',
  3406: 'America/New_York',
  3407: 'America/New_York',
  3408: 'America/New_York',
  3409: 'America/New_York',
  3480: 'America/New_York',
  3481: 'America/New_York',
  3482: 'America/New_York',
  3484: 'America/New_York',
  3485: 'America/New_York',
  3486: 'America/New_York',
  3487: 'America/New_York',
  3488: 'America/New_York',
  3489: 'America/New_York',
  3501: 'America/Denver',
  3502: 'America/Denver',
  3503: 'America/Denver',
  3504: 'America/Denver',
  3505: 'America/Denver',
  3507: 'America/Denver',
  3508: 'America/Denver',
  3510: 'America/Denver',
  3511: 'America/Denver',
  3514: 'America/Denver',
  3515: 'America/Denver',
  3516: 'America/Denver',
  3517: 'America/Denver',
  3601: 'America/New_York',
  3602: 'America/New_York',
  3603: 'America/New_York',
  3604: 'America/New_York',
  3605: 'America/New_York',
  3606: 'America/New_York',
  3607: 'America/New_York',
  3608: 'America/New_York',
  3609: 'America/New_York',
  3610: 'America/New_York',
  3615: 'America/New_York',
  3616: 'America/New_York',
  3620: 'America/New_York',
  3625: 'America/New_York',
  3626: 'America/New_York',
  3627: 'America/New_York',
  3628: 'America/New_York',
  3629: 'America/New_York',
  3631: 'America/New_York',
  3632: 'America/New_York',
  3633: 'America/New_York',
  3634: 'America/New_York',
  3637: 'America/New_York',
  3638: 'America/New_York',
  3639: 'America/New_York',
  3640: 'America/New_York',
  3641: 'America/New_York',
  3642: 'America/New_York',
  3644: 'America/New_York',
  3645: 'America/New_York',
  3646: 'America/New_York',
  3647: 'America/New_York',
  3648: 'America/New_York',
  3650: 'America/New_York',
  3651: 'America/New_York',
  3652: 'America/New_York',
  3655: 'America/New_York',
  3661: 'America/New_York',
  3662: 'America/New_York',
  3663: 'America/New_York',
  3701: 'America/Chicago',
  3703: 'America/Chicago',
  3801: 'America/New_York',
  3803: 'America/New_York',
  3804: 'America/New_York',
  3805: 'America/New_York',
  3806: 'America/New_York',
  3807: 'America/New_York',
  3808: 'America/New_York',
  3809: 'America/New_York',
  3810: 'America/New_York',
  3811: 'America/New_York',
  3812: 'America/New_York',
  3813: 'America/New_York',
  3814: 'America/New_York',
  3815: 'America/New_York',
  3816: 'America/New_York',
  3817: 'America/New_York',
  3818: 'America/New_York',
  3819: 'America/New_York',
  3820: 'America/New_York',
  3821: 'America/New_York',
  3822: 'America/New_York',
  3823: 'America/New_York',
  3824: 'America/New_York',
  3825: 'America/New_York',
  3827: 'America/New_York',
  3828: 'America/New_York',
  3830: 'America/New_York',
  3831: 'America/New_York',
  3832: 'America/New_York',
  3833: 'America/New_York',
  3835: 'America/New_York',
  3836: 'America/New_York',
  3838: 'America/New_York',
  3841: 'America/New_York',
  3842: 'America/New_York',
  3843: 'America/New_York',
  3844: 'America/New_York',
  3846: 'America/New_York',
  3847: 'America/New_York',
  3848: 'America/New_York',
  3852: 'America/New_York',
  3854: 'America/New_York',
  3855: 'America/New_York',
  3856: 'America/New_York',
  3857: 'America/New_York',
  3858: 'America/New_York',
  3859: 'America/New_York',
  3860: 'America/New_York',
  3861: 'America/New_York',
  3862: 'America/New_York',
  3863: 'America/New_York',
  3864: 'America/New_York',
  3866: 'America/New_York',
  3867: 'America/New_York',
  3868: 'America/New_York',
  3872: 'America/New_York',
  3875: 'America/New_York',
  3877: 'America/New_York',
  3882: 'America/New_York',
  3883: 'America/New_York',
  3885: 'America/New_York',
  3886: 'America/New_York',
  3887: 'America/New_York',
  3888: 'America/New_York',
  3889: 'America/New_York',
  3901: 'America/Chicago',
  3902: 'America/Chicago',
  3903: 'America/Chicago',
  3904: 'America/Chicago',
  3906: 'America/Chicago',
  3907: 'America/Chicago',
  3908: 'America/Chicago',
  3909: 'America/Chicago',
  3911: 'America/Chicago',
  3913: 'America/Chicago',
  3914: 'America/Chicago',
  3915: 'America/Chicago',
  3917: 'America/Chicago',
  3918: 'America/Chicago',
  3919: 'America/Chicago',
  4001: 'America/Los_Angeles',
  4002: 'America/Los_Angeles',
  4003: 'America/Los_Angeles',
  4004: 'America/Los_Angeles',
  4006: 'America/Los_Angeles',
  4007: 'America/Los_Angeles',
  4008: 'America/Los_Angeles',
  4009: 'America/Los_Angeles',
  4010: 'America/Los_Angeles',
  4013: 'America/Los_Angeles',
  4014: 'America/Los_Angeles',
  4015: 'America/Los_Angeles',
  4017: 'America/Los_Angeles',
  4018: 'America/Los_Angeles',
  4019: 'America/Los_Angeles',
  4020: 'America/Los_Angeles',
  4023: 'America/Los_Angeles',
  4025: 'America/Boise',
  4026: 'America/Los_Angeles',
  4028: 'America/Los_Angeles',
  4029: 'America/Los_Angeles',
  4030: 'America/Los_Angeles',
  4031: 'America/Los_Angeles',
  4032: 'America/Los_Angeles',
  4034: 'America/Los_Angeles',
  4040: 'America/Los_Angeles',
  4101: 'America/New_York',
  4102: 'America/New_York',
  4103: 'America/New_York',
  4104: 'America/New_York',
  4105: 'America/New_York',
  4106: 'America/New_York',
  4108: 'America/New_York',
  4109: 'America/New_York',
  4110: 'America/New_York',
  4112: 'America/New_York',
  4113: 'America/New_York',
  4114: 'America/New_York',
  4115: 'America/New_York',
  4116: 'America/New_York',
  4117: 'America/New_York',
  4118: 'America/New_York',
  4119: 'America/New_York',
  4120: 'America/New_York',
  4121: 'America/New_York',
  4122: 'America/New_York',
  4123: 'America/New_York',
  4124: 'America/New_York',
  4125: 'America/New_York',
  4126: 'America/New_York',
  4127: 'America/New_York',
  4128: 'America/New_York',
  4129: 'America/New_York',
  4130: 'America/New_York',
  4131: 'America/New_York',
  4132: 'America/New_York',
  4134: 'America/New_York',
  4135: 'America/New_York',
  4136: 'America/New_York',
  4137: 'America/New_York',
  4138: 'America/New_York',
  4139: 'America/New_York',
  4140: 'America/New_York',
  4141: 'America/New_York',
  4142: 'America/New_York',
  4143: 'America/New_York',
  4145: 'America/New_York',
  4148: 'America/New_York',
  4149: 'America/New_York',
  4150: 'America/New_York',
  4152: 'America/New_York',
  4156: 'America/New_York',
  4158: 'America/New_York',
  4159: 'America/New_York',
  4160: 'America/New_York',
  4162: 'America/New_York',
  4163: 'America/New_York',
  4164: 'America/New_York',
  4166: 'America/New_York',
  4168: 'America/New_York',
  4169: 'America/New_York',
  4171: 'America/New_York',
  4172: 'America/New_York',
  4173: 'America/New_York',
  4176: 'America/New_York',
  4177: 'America/New_York',
  4178: 'America/New_York',
  4180: 'America/New_York',
  4181: 'America/New_York',
  4185: 'America/New_York',
  4187: 'America/New_York',
  4188: 'America/New_York',
  4279: 'America/New_York',
  4280: 'America/New_York',
  4282: 'America/New_York',
  4283: 'America/New_York',
  4284: 'America/New_York',
  4285: 'America/New_York',
  4286: 'America/New_York',
  4287: 'America/New_York',
  4301: 'America/Chicago',
  4401: 'America/Denver',
  4402: 'America/Denver',
  4403: 'America/Denver',
  4406: 'America/Denver',
  4407: 'America/Denver',
  4408: 'America/Denver',
  4409: 'America/Denver',
  4410: 'America/Denver',
  4411: 'America/Denver',
  4412: 'America/Denver',
  4413: 'America/Denver',
  4414: 'America/Denver',
  4415: 'America/Denver',
  4416: 'America/Denver',
  4417: 'America/Denver',
  4418: 'America/Denver',
  4419: 'America/Denver',
  4420: 'America/Denver',
  4421: 'America/Denver',
  4422: 'America/Denver',
  4501: 'America/New_York',
  4502: 'America/New_York',
  4551: 'America/New_York',
  4601: 'America/New_York',
  4602: 'America/New_York',
  4603: 'America/New_York',
  4604: 'America/New_York',
  4605: 'America/New_York',
  4607: 'America/New_York',
  4608: 'America/New_York',
  4609: 'America/New_York',
  4611: 'America/New_York',
  4612: 'America/New_York',
  4613: 'America/New_York',
  4614: 'America/New_York',
  4615: 'America/New_York',
  4616: 'America/New_York',
  4617: 'America/New_York',
  4618: 'America/New_York',
  4619: 'America/New_York',
  4620: 'America/New_York',
  4621: 'America/New_York',
  4622: 'America/New_York',
  4624: 'America/New_York',
  4626: 'America/New_York',
  4627: 'America/New_York',
  4628: 'America/New_York',
  4631: 'America/New_York',
  4632: 'America/New_York',
  4633: 'America/New_York',
  4634: 'America/New_York',
  4635: 'America/New_York',
  4637: 'America/New_York',
  4638: 'America/New_York',
  4639: 'America/New_York',
  4640: 'America/New_York',
  4641: 'America/New_York',
  4643: 'America/New_York',
  4645: 'America/New_York',
  4647: 'America/New_York',
  4648: 'America/New_York',
  4650: 'America/New_York',
  4653: 'America/New_York',
  4654: 'America/New_York',
  4655: 'America/New_York',
  4656: 'America/New_York',
  4658: 'America/New_York',
  4659: 'America/New_York',
  4660: 'America/New_York',
  4701: 'America/Los_Angeles',
  4702: 'America/Los_Angeles',
  4703: 'America/Los_Angeles',
  4704: 'America/Los_Angeles',
  4705: 'America/Los_Angeles',
  4706: 'America/Los_Angeles',
  4707: 'America/Los_Angeles',
  4708: 'America/Los_Angeles',
  4709: 'America/Los_Angeles',
  4711: 'America/Los_Angeles',
  4712: 'America/Los_Angeles',
  4713: 'America/Los_Angeles',
  4714: 'America/Los_Angeles',
  4715: 'America/Los_Angeles',
  4716: 'America/Los_Angeles',
  4718: 'America/Los_Angeles',
  4719: 'America/Los_Angeles',
  4720: 'America/Los_Angeles',
  4722: 'America/Los_Angeles',
  4723: 'America/Los_Angeles',
  4724: 'America/Los_Angeles',
  4725: 'America/Los_Angeles',
  4726: 'America/Los_Angeles',
  4727: 'America/Los_Angeles',
  4728: 'America/Los_Angeles',
  4732: 'America/Los_Angeles',
  4735: 'America/Los_Angeles',
  4737: 'America/Los_Angeles',
  4738: 'America/Los_Angeles',
  4739: 'America/Los_Angeles',
  4740: 'America/Los_Angeles',
  4741: 'America/Los_Angeles',
  4742: 'America/Los_Angeles',
  4743: 'America/Los_Angeles',
  4745: 'America/Los_Angeles',
  4746: 'America/Los_Angeles',
  4747: 'America/Los_Angeles',
  4748: 'America/Los_Angeles',
  4801: 'America/New_York',
  4802: 'America/New_York',
  4803: 'America/New_York',
  4805: 'America/New_York',
  4878: 'America/New_York',
  4902: 'America/Chicago',
  4903: 'America/Chicago',
  4905: 'America/Chicago',
  4906: 'America/Chicago',
  4907: 'America/Chicago',
  4909: 'America/Chicago',
  4910: 'America/Chicago',
  4911: 'America/Chicago',
  4912: 'America/Chicago',
  4915: 'America/Chicago',
  4916: 'America/Chicago',
  4918: 'America/Chicago',
  4919: 'America/Chicago',
  4920: 'America/Chicago',
  4921: 'America/Chicago',
  4923: 'America/Chicago',
  4924: 'America/Chicago',
  4925: 'America/Chicago',
  4926: 'America/Chicago',
  4928: 'America/Chicago',
  4929: 'America/Chicago',
  4930: 'America/Chicago',
  4931: 'America/Chicago',
  4935: 'America/Chicago',
  4940: 'America/Chicago',
  4941: 'America/Chicago',
  4942: 'America/Chicago',
  6001: 'America/Denver',
  6002: 'America/Denver',
  6003: 'America/Denver',
  6004: 'America/Denver',
  6005: 'America/Denver',
  6105: 'America/New_York',
  6150: 'America/New_York',
  6152: 'America/New_York',
  6153: 'America/New_York',
  6154: 'America/New_York',
  6155: 'America/New_York',
  6158: 'America/New_York',
  6159: 'America/New_York',
  6160: 'America/New_York',
  6161: 'America/New_York',
  6167: 'America/New_York',
  6168: 'America/New_York',
  6169: 'America/New_York',
  6172: 'America/New_York',
  6173: 'America/New_York',
  6174: 'America/New_York',
  6175: 'America/New_York',
  6176: 'America/New_York',
  6177: 'America/New_York',
  6178: 'America/New_York',
  6201: 'America/New_York',
  6202: 'America/New_York',
  6203: 'America/New_York',
  6204: 'America/New_York',
  6206: 'America/New_York',
  6207: 'America/New_York',
  6208: 'America/New_York',
  6209: 'America/New_York',
  6210: 'America/New_York',
  6212: 'America/New_York',
  6213: 'America/New_York',
  6214: 'America/New_York',
  6215: 'America/New_York',
  6217: 'America/New_York',
  6218: 'America/New_York',
  6220: 'America/New_York',
  6221: 'America/New_York',
  6223: 'America/New_York',
  6225: 'America/New_York',
  6226: 'America/New_York',
  6228: 'America/New_York',
  6229: 'America/New_York',
  6230: 'America/New_York',
  6233: 'America/New_York',
  6234: 'America/New_York',
  6235: 'America/New_York',
  6236: 'America/New_York',
  6242: 'America/New_York',
  6301: 'America/Chicago',
  6302: 'America/New_York',
  6303: 'America/Chicago',
  6304: 'America/New_York',
  6305: 'America/New_York',
  6306: 'America/New_York',
  6310: 'America/New_York',
  6311: 'America/New_York',
  6312: 'America/New_York',
  6313: 'America/New_York',
  6314: 'America/New_York',
  6315: 'America/New_York',
  6316: 'America/New_York',
  6319: 'America/New_York',
  6320: 'America/New_York',
  6321: 'America/New_York',
  6322: 'America/New_York',
  6323: 'America/New_York',
  6324: 'America/New_York',
  6325: 'America/New_York',
  6326: 'America/New_York',
  6327: 'America/New_York',
  6328: 'America/New_York',
  6329: 'America/New_York',
  6330: 'America/New_York',
  6331: 'America/New_York',
  6332: 'America/New_York',
  6334: 'America/New_York',
  6335: 'America/New_York',
  6336: 'America/New_York',
  6339: 'America/New_York',
  6340: 'America/New_York',
  6341: 'America/New_York',
  6343: 'America/New_York',
  6346: 'America/New_York',
  6348: 'America/New_York',
  6349: 'America/New_York',
  6350: 'America/New_York',
  6351: 'America/New_York',
  6353: 'America/New_York',
  6355: 'America/New_York',
  6356: 'America/New_York',
  6357: 'America/New_York',
  6361: 'America/New_York',
  6363: 'America/New_York',
  6364: 'America/New_York',
  6365: 'America/New_York',
  6367: 'America/New_York',
  6368: 'America/Chicago',
  6369: 'America/New_York',
  6371: 'America/New_York',
  6372: 'America/New_York',
  6373: 'America/New_York',
  6374: 'America/New_York',
  6375: 'America/New_York',
  6376: 'America/New_York',
  6377: 'America/Chicago',
  6378: 'America/New_York',
  6379: 'America/New_York',
  6380: 'America/New_York',
  6381: 'America/New_York',
  6401: 'America/Puerto_Rico',
  6403: 'America/Puerto_Rico',
  6411: 'America/Puerto_Rico',
  6412: 'America/Puerto_Rico',
  6415: 'America/Puerto_Rico',
  6501: 'America/Chicago',
  6502: 'America/Chicago',
  6503: 'America/Chicago',
  6504: 'America/Chicago',
  6505: 'America/Chicago',
  6506: 'America/Chicago',
  6507: 'America/Chicago',
  6509: 'America/Chicago',
  6510: 'America/Chicago',
  6512: 'America/Chicago',
  6513: 'America/Chicago',
  6514: 'America/Chicago',
  6515: 'America/Chicago',
  6516: 'America/Chicago',
  6517: 'America/Chicago',
  6520: 'America/Chicago',
  6521: 'America/Chicago',
  6523: 'America/Chicago',
  6525: 'America/Chicago',
  6526: 'America/Chicago',
  6528: 'America/Chicago',
  6529: 'America/Chicago',
  6530: 'America/Chicago',
  6531: 'America/Chicago',
  6532: 'America/Chicago',
  6533: 'America/Chicago',
  6534: 'America/Chicago',
  6537: 'America/Chicago',
  6538: 'America/Chicago',
  6539: 'America/Chicago',
  6540: 'America/Chicago',
  6542: 'America/Chicago',
  6543: 'America/Chicago',
  6544: 'America/Chicago',
  6545: 'America/Chicago',
  6546: 'America/Chicago',
  6547: 'America/Chicago',
  6548: 'America/Chicago',
  6549: 'America/Chicago',
  6550: 'America/Chicago',
  6551: 'America/Chicago',
  6552: 'America/Chicago',
  6553: 'America/Chicago',
  6554: 'America/Chicago',
  6555: 'America/Chicago',
  6556: 'America/Chicago',
  6557: 'America/Chicago',
  6558: 'America/Chicago',
  6559: 'America/Chicago',
  6560: 'America/Chicago',
  6561: 'America/Chicago',
  6562: 'America/Chicago',
  6563: 'America/Chicago',
  6564: 'America/Chicago',
  6566: 'America/Chicago',
  6567: 'America/Chicago',
  6568: 'America/Chicago',
  6570: 'America/Chicago',
  6571: 'America/Chicago',
  6572: 'America/Chicago',
  6574: 'America/Chicago',
  6575: 'America/Chicago',
  6576: 'America/Chicago',
  6577: 'America/Chicago',
  6578: 'America/Chicago',
  6579: 'America/Chicago',
  6580: 'America/Chicago',
  6581: 'America/Chicago',
  6583: 'America/Chicago',
  6584: 'America/Chicago',
  6585: 'America/Chicago',
  6586: 'America/Chicago',
  6587: 'America/Chicago',
  6588: 'America/Chicago',
  6589: 'America/Chicago',
  6601: 'America/Los_Angeles',
  6603: 'America/Los_Angeles',
  6604: 'America/Los_Angeles',
  6609: 'America/Los_Angeles',
  6610: 'America/Los_Angeles',
  6611: 'America/Los_Angeles',
  6612: 'America/Los_Angeles',
  6613: 'America/Los_Angeles',
  6614: 'America/Los_Angeles',
  6615: 'America/Los_Angeles',
  6616: 'America/Los_Angeles',
  6617: 'America/Los_Angeles',
  6618: 'America/Los_Angeles',
  6619: 'America/Los_Angeles',
  6620: 'America/Los_Angeles',
  6621: 'America/Los_Angeles',
  6623: 'America/Los_Angeles',
  6627: 'America/Los_Angeles',
  6628: 'America/Los_Angeles',
  6629: 'America/Los_Angeles',
  6630: 'America/Los_Angeles',
  6632: 'America/Los_Angeles',
  6634: 'America/Los_Angeles',
  6635: 'America/Los_Angeles',
  6636: 'America/Los_Angeles',
  6637: 'America/Los_Angeles',
  6638: 'America/Los_Angeles',
  6639: 'America/Los_Angeles',
  6640: 'America/Los_Angeles',
  6643: 'America/Los_Angeles',
  6644: 'America/Los_Angeles',
  6645: 'America/Los_Angeles',
  6646: 'America/Los_Angeles',
  6647: 'America/Los_Angeles',
  6649: 'America/Los_Angeles',
  6650: 'America/Los_Angeles',
  6651: 'America/Los_Angeles',
  6652: 'America/Los_Angeles',
  6654: 'America/Los_Angeles',
  6655: 'America/Los_Angeles',
  6656: 'America/Los_Angeles',
  6657: 'America/Los_Angeles',
  6660: 'America/Los_Angeles',
  6661: 'America/Los_Angeles',
  6662: 'America/Los_Angeles',
  6663: 'America/Los_Angeles',
  6664: 'America/Los_Angeles',
  6665: 'America/Los_Angeles',
  6667: 'America/Los_Angeles',
  6668: 'America/Los_Angeles',
  6669: 'America/Los_Angeles',
  6670: 'America/Los_Angeles',
  6672: 'America/Los_Angeles',
  6673: 'America/Los_Angeles',
  6674: 'America/Los_Angeles',
  6675: 'America/Los_Angeles',
  6677: 'America/Los_Angeles',
  6678: 'America/Los_Angeles',
  6679: 'America/Los_Angeles',
  6680: 'America/Los_Angeles',
  6681: 'America/Los_Angeles',
  6682: 'America/Los_Angeles',
  6683: 'America/Los_Angeles',
  6684: 'America/Los_Angeles',
  6687: 'America/Los_Angeles',
  6688: 'America/Los_Angeles',
  6689: 'America/Los_Angeles',
  6701: 'America/Chicago',
  6804: 'America/Chicago',
  6806: 'America/Chicago',
  6807: 'America/Chicago',
  6808: 'America/Chicago',
  6809: 'America/Chicago',
  6814: 'America/Chicago',
  6816: 'America/Chicago',
  6817: 'America/Chicago',
  6818: 'America/Chicago',
  6819: 'America/Chicago',
  6820: 'America/Chicago',
  6821: 'America/Detroit',
  6822: 'America/Chicago',
  6827: 'America/Chicago',
  6828: 'America/Chicago',
  6830: 'America/Chicago',
  6831: 'America/Chicago',
  6832: 'America/Chicago',
  6833: 'America/Chicago',
  6834: 'America/Los_Angeles',
  6835: 'America/Los_Angeles',
  6838: 'America/Chicago',
  6839: 'America/Chicago',
  6840: 'America/Chicago',
  6841: 'America/New_York',
  6843: 'America/New_York',
  6844: 'America/New_York',
  6845: 'America/New_York',
  6846: 'America/New_York',
  6848: 'America/New_York',
  6851: 'America/New_York',
  6852: 'America/New_York',
  6853: 'America/Chicago',
  6855: 'America/Los_Angeles',
  6856: 'America/New_York',
  6857: 'America/New_York',
  6859: 'America/Chicago',
  6860: 'America/Chicago',
  6861: 'America/New_York',
  6862: 'America/Phoenix',
  6863: 'America/Chicago',
  6864: 'America/New_York',
  6865: 'America/New_York',
  6866: 'America/New_York',
  6869: 'America/New_York',
  6871: 'America/New_York',
  6872: 'America/New_York',
  6874: 'America/Los_Angeles',
  6875: 'America/Los_Angeles',
  6876: 'America/Los_Angeles',
  6877: 'America/New_York',
  6878: 'America/New_York',
  6883: 'America/Los_Angeles',
  6884: 'America/Los_Angeles',
  6887: 'America/Chicago',
  6888: 'America/New_York',
  6889: 'America/Chicago',
  6890: 'America/New_York',
  6891: 'America/New_York',
  6892: 'America/Chicago',
  6893: 'America/Los_Angeles',
  6903: 'America/New_York',
  6905: 'America/New_York',
  6911: 'America/New_York',
  6917: 'America/New_York',
  6918: 'America/New_York',
  6919: 'America/Chicago',
  6920: 'America/Chicago',
  6921: 'America/New_York',
  6923: 'America/Chicago',
  6925: 'America/Chicago',
  6928: 'America/New_York',
  6930: 'America/New_York',
  6931: 'America/New_York',
  6932: 'America/Chicago',
  6934: 'America/New_York',
  6935: 'America/New_York',
  6936: 'America/New_York',
  6940: 'America/New_York',
  6941: 'America/New_York',
  6942: 'America/New_York',
  6943: 'America/New_York',
  6945: 'America/New_York',
  6946: 'America/Los_Angeles',
  6947: 'America/Los_Angeles',
  6948: 'America/Phoenix',
  6950: 'America/New_York',
  6951: 'America/New_York',
  6952: 'America/Los_Angeles',
  6954: 'America/New_York',
  6955: 'America/New_York',
  6956: 'America/New_York',
  6957: 'America/New_York',
  6959: 'America/New_York',
  6960: 'America/Los_Angeles',
  6961: 'America/Chicago',
  6963: 'America/Los_Angeles',
  6964: 'America/Los_Angeles',
  6965: 'America/Los_Angeles',
  6966: 'America/Los_Angeles',
  6967: 'America/Los_Angeles',
  6968: 'America/Los_Angeles',
  6971: 'America/Los_Angeles',
  6972: 'America/Los_Angeles',
  6974: 'America/New_York',
  6975: 'America/New_York',
  6976: 'America/New_York',
  6977: 'America/New_York',
  6978: 'America/New_York',
  6979: 'America/New_York',
  6980: 'America/New_York',
  6981: 'America/Chicago',
  6984: 'America/Chicago',
  6985: 'America/Chicago',
  6986: 'America/New_York',
  6987: 'America/Chicago',
  6988: 'America/Chicago',
  6989: 'America/Chicago',
  7001: 'America/Toronto',
  7002: 'America/Toronto',
  7003: 'America/Toronto',
  7004: 'America/Toronto',
  7005: 'America/Toronto',
  7006: 'America/Toronto',
  7007: 'America/Toronto',
  7008: 'America/Toronto',
  7009: 'America/Toronto',
  7011: 'America/Toronto',
  7012: 'America/Toronto',
  7013: 'America/Toronto',
  7017: 'America/Toronto',
  7021: 'America/Toronto',
  7022: 'America/Toronto',
  7023: 'America/Toronto',
  7024: 'America/Toronto',
  7025: 'America/Toronto',
  7026: 'America/Toronto',
  7027: 'America/Toronto',
  7030: 'America/Toronto',
  7032: 'America/Vancouver',
  7033: 'America/Toronto',
  7034: 'America/Toronto',
  7035: 'America/Vancouver',
  7036: 'America/Edmonton',
  7037: 'America/Edmonton',
  7038: 'America/Winnipeg',
  7040: 'America/Vancouver',
  7041: 'America/Vancouver',
  7042: 'America/Vancouver',
  7043: 'America/Vancouver',
  7044: 'America/Vancouver',
  7045: 'America/Vancouver',
  7046: 'America/Vancouver',
  7047: 'America/Vancouver',
  7050: 'America/Edmonton',
  7051: 'America/Regina',
  7052: 'America/Regina',
  7053: 'America/Vancouver',
  7055: 'America/Vancouver',
  7056: 'America/Winnipeg',
  7057: 'America/Winnipeg',
  7058: 'America/Winnipeg',
  7061: 'America/Edmonton',
  7062: 'America/Edmonton',
  7063: 'America/Edmonton',
  7064: 'America/Edmonton',
  7065: 'America/Edmonton',
  7067: 'America/Edmonton',
  7073: 'America/Toronto',
  7074: 'America/Vancouver',
  7075: 'America/Toronto',
  7076: 'America/Edmonton',
  7077: 'America/St_Johns',
  7078: 'America/Toronto',
  7079: 'America/Toronto',
  7080: 'America/Toronto',
  7081: 'America/Toronto',
  7082: 'America/Edmonton',
  7084: 'America/Vancouver',
  7085: 'America/Toronto',
  7086: 'America/Winnipeg',
  7087: 'America/Toronto',
  7088: 'America/Edmonton',
  7089: 'America/Toronto',
  7102: 'America/Toronto',
  7103: 'America/Halifax',
  7105: 'America/Toronto',
  7106: 'America/Toronto',
  7107: 'America/Toronto',
  7108: 'America/Toronto',
  7109: 'America/Toronto',
  7110: 'America/Toronto',
  7111: 'America/Edmonton',
  7112: 'America/Toronto',
  7114: 'America/Toronto',
  7115: 'America/Toronto',
  7116: 'America/Toronto',
  7117: 'America/Edmonton',
  7118: 'America/Toronto',
  7119: 'America/Edmonton',
  7122: 'America/Vancouver',
  7123: 'America/Toronto',
  7124: 'America/Toronto',
  7126: 'America/Halifax',
  7128: 'America/Toronto',
  7129: 'America/Toronto',
  7130: 'America/Toronto',
  7131: 'America/Edmonton',
  7132: 'America/Toronto',
  7133: 'America/Toronto',
  7134: 'America/Toronto',
  7135: 'America/Toronto',
  7136: 'America/Toronto',
  7137: 'America/Toronto',
  7138: 'America/Toronto',
  7139: 'America/Toronto',
  7140: 'America/Toronto',
  7141: 'America/Vancouver',
  7142: 'America/Toronto',
  7144: 'America/Vancouver',
  7145: 'America/Vancouver',
  7146: 'America/Toronto',
  7147: 'America/Toronto',
  7148: 'America/Halifax',
  7149: 'America/Toronto',
  7150: 'America/Toronto',
  7151: 'America/Halifax',
  7152: 'America/Toronto',
  7153: 'America/Toronto',
  7154: 'America/Toronto',
  7156: 'America/Toronto',
  7157: 'America/Toronto',
  7158: 'America/Toronto',
  7159: 'America/Toronto',
  7160: 'America/Toronto',
  7161: 'America/Toronto',
  7162: 'America/Toronto',
  7163: 'America/Toronto',
  7164: 'America/Toronto',
  7166: 'America/Toronto',
  7167: 'America/Toronto',
  7169: 'America/Toronto',
  7170: 'America/Edmonton',
  7171: 'America/Vancouver',
  7172: 'America/Edmonton',
  7173: 'America/Halifax',
  7174: 'America/Toronto',
  7175: 'America/Edmonton',
  7177: 'America/Vancouver',
  7178: 'America/Toronto',
  7179: 'America/Toronto',
  7180: 'America/Winnipeg',
  7182: 'America/Toronto',
  7184: 'America/Toronto',
  7185: 'America/Toronto',
  7187: 'America/Toronto',
  7188: 'America/Toronto',
  7189: 'America/Toronto',
  7221: 'America/Vancouver',
  7222: 'America/Edmonton',
  7223: 'America/Edmonton',
  7224: 'America/Toronto',
  7226: 'America/Toronto',
  7227: 'America/Edmonton',
  7228: 'America/Toronto',
  7233: 'America/Halifax',
  7234: 'America/Toronto',
  7236: 'America/Toronto',
  7237: 'America/Toronto',
  7238: 'America/Toronto',
  7239: 'America/Toronto',
  7240: 'America/Toronto',
  7241: 'America/Toronto',
  7242: 'America/Toronto',
  7244: 'America/Toronto',
  7245: 'America/Regina',
  7247: 'America/Toronto',
  7248: 'America/Edmonton',
  7249: 'America/Toronto',
  7250: 'America/Edmonton',
  7251: 'America/Toronto',
  7252: 'America/Vancouver',
  7253: 'America/Toronto',
  7254: 'America/Edmonton',
  7255: 'America/Edmonton',
  7256: 'America/Toronto',
  7257: 'America/Halifax',
  7258: 'America/Edmonton',
  7259: 'America/Vancouver',
  7261: 'America/Halifax',
  7262: 'America/Toronto',
  7263: 'America/Toronto',
  7264: 'America/Toronto',
  7265: 'America/Regina',
  7266: 'America/Toronto',
  7268: 'America/Edmonton',
  7269: 'America/Toronto',
  7272: 'America/Vancouver',
  7273: 'America/Vancouver',
  7301: 'America/Toronto',
  8408: 'America/Los_Angeles',
  8412: 'America/New_York',
  8413: 'America/New_York',
  8418: 'America/Chicago',
  8419: 'America/Chicago',
  8426: 'America/Los_Angeles',
  8427: 'America/Los_Angeles',
  8429: 'America/New_York',
  8430: 'America/Chicago',
  8431: 'America/Chicago',
  8433: 'America/New_York',
  8437: 'America/Chicago',
  8438: 'America/Chicago',
  8439: 'America/Chicago',
  8440: 'America/New_York',
  8444: 'America/New_York',
  8445: 'America/Chicago',
  8446: 'America/Chicago',
  8447: 'America/New_York',
  8452: 'America/New_York',
  8453: 'Pacific/Honolulu',
  8454: 'America/Chicago',
  8456: 'America/New_York',
  8460: 'America/Chicago',
  8463: 'America/Los_Angeles',
  8465: 'America/New_York',
  8466: 'America/New_York',
  8469: 'America/Chicago',
  8472: 'America/Chicago',
  8473: 'America/New_York',
  8475: 'America/New_York',
  8488: 'America/Phoenix',
  8492: 'America/Los_Angeles',
  8493: 'America/New_York',
  8517: 'America/Chicago',
  8518: 'America/Chicago',
  8519: 'America/Chicago',
  8520: 'America/Chicago',
  8521: 'America/Chicago',
  8523: 'America/Denver',
  8524: 'America/Los_Angeles',
  8525: 'America/Los_Angeles',
  8526: 'America/Los_Angeles',
  8527: 'America/New_York',
  8528: 'America/New_York',
  8529: 'America/Los_Angeles',
  8531: 'America/New_York',
  8537: 'America/Chicago',
  8539: 'America/New_York',
  8540: 'America/Chicago',
  8545: 'America/New_York',
  8548: 'America/New_York',
  8550: 'America/New_York',
  8551: 'America/New_York',
  8552: 'America/New_York',
  8557: 'America/Los_Angeles',
  8560: 'America/Los_Angeles',
  8561: 'America/Los_Angeles',
  8562: 'America/Los_Angeles',
  8563: 'America/Los_Angeles',
  8566: 'America/Denver',
  8571: 'America/Los_Angeles',
  8572: 'America/Los_Angeles',
  8577: 'America/Chicago',
  8580: 'America/New_York',
  8582: 'America/Phoenix',
  8583: 'America/Denver',
  8584: 'America/New_York',
  8597: 'America/Los_Angeles',
  8598: 'America/Chicago',
  8913: 'America/New_York',
  8916: 'America/Chicago',
  8918: 'America/Indiana/Indianapolis',
  8919: 'America/Chicago',
  8922: 'America/Chicago',
  8923: 'America/New_York',
  8924: 'America/New_York',
  8926: 'America/New_York',
  8929: 'America/New_York',
  8931: 'America/New_York',
  8938: 'America/Anchorage',
  8939: 'America/Anchorage',
  8940: 'America/Anchorage',
  8941: 'America/Boise',
  8944: 'America/Los_Angeles',
  8949: 'America/Los_Angeles',
  8951: 'America/Chicago',
  8954: 'America/New_York',
  8955: 'America/New_York',
  8958: 'America/New_York',
  8964: 'America/Los_Angeles',
  8966: 'America/Los_Angeles',
  8975: 'America/Los_Angeles',
  8976: 'America/Chicago',
  8979: 'America/New_York',
  8981: 'America/New_York',
  8984: 'America/Chicago',
  8987: 'America/Los_Angeles',
  8988: 'America/Los_Angeles',
  8994: 'America/Chicago',
  8995: 'America/Chicago',
  8996: 'America/New_York',
  8998: 'America/Los_Angeles',
  9710: 'America/New_York',
  9749: 'America/New_York',
  9764: 'America/New_York',
  9765: 'America/Toronto',
  9742: 'America/Toronto',
  9751: 'America/New_York'
};
